import axios from 'axios';
import router from '../router';

const state = {
// users state
  users: []
};

const mutations = {
// users mutations
    SET_USERS(state, users) {
        state.users = users;
    }
};

const actions = {
  async fetchUsers({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
        const response = await axios.get(`${baseUrl}/users`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_USERS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching users:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getUserByID({ commit }, userId) { // Change from destructuring to direct variable
    console.log('Fetching user with ID:', userId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
        const response = await axios.get(`${baseUrl}/users/${userId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('User fetch response:', response.data);
        commit('SET_USERS', response.data);
    } catch (error) {
        console.error('Error fetching user:', error);
        throw error;
    }
  },
  async createUser({ dispatch }, { user }) {
    console.log('Creating user:', user);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
      await axios.post(`${baseUrl}/users`, user,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('User created:', user);
      dispatch('fetchUsers', { search: '' });
    } catch (error) {
      console.error('Error creating user:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  },
  async updateUser({ dispatch }, { user }) {
    console.log('Updating user:', user);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.put(`${baseUrl}/users/${user.id}`, user,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('User updated:', user);
      dispatch('fetchUsers', { search: '' });
    } catch (error) {
      console.error('Error updating user:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  },
  async deleteUser({ dispatch }, { user }) {
    console.log('Deleting user:', user);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
      await axios.delete(`${baseUrl}/users/${user}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('User deleted:', user);
      dispatch('fetchUsers', { search: '' });
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  },
  // Set the product-edit permission for a single user via the settings route.
  // value: true = allowed, false = blocked, null = inherit from company.
  // NOTE: does NOT re-fetch the user list — the view updates the row locally
  // (and bulk operations refresh once at the end instead of per user).
  async setProductEditPermission(_, { userId, value }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
    await axios.put(`${baseUrl}/users/${userId}/settings`,
      { allowProductEdit: value },
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
  },
  // Company-wide default for the product-edit permission. Affects every user
  // whose override is "inherit from company".
  async getCompanyProductEdit() {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return null;
    }

    const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
    const response = await axios.get(`${baseUrl}/account-settings`,
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
    return response.data;
  },
  // value: true = allowed, false = blocked (the company default is binary —
  // "inherit" only exists at the user level).
  async setCompanyProductEdit(_, { value }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }

    const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
    await axios.put(`${baseUrl}/account-settings`,
      { allowProductEdit: value ? 1 : 0 },
      { headers: { Authorization: `Bearer ${userToken}` } }
    );
  }
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};